import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { Switch, Text } from "@pentabd/ui";

import { InputTextRow } from "@components";

import {
  AcrFormDataType,
  BASIC_INFO,
} from "@validations/HRM/employee/acrValidation";

export const BasicInfo = () => {
  const { t } = useTranslation();

  const {
    register,
    formState: { errors },
    control,
    setValue,
  } = useFormContext<AcrFormDataType>();

  return (
    <div className="pb-9 d-flex flex-column gap-8">
      <InputTextRow
        register={{ ...register(BASIC_INFO.GRADATION_NO) }}
        label="EMPLOYEE.ACR_INFO.FORM.GRADATION"
        error={errors}
        required
      />
      <InputTextRow
        register={{ ...register(BASIC_INFO.AVERAGE_MARKS_OF_ACR) }}
        label="EMPLOYEE.ACR_INFO.FORM.AVERAGE_MARKS_ACR"
        error={errors}
      />

      <div className="row">
        <div className="col-md-12 col-lg-3">
          <Text weight="semibold" size="sm" color="title">
            {t("EMPLOYEE.ACR_INFO.FORM.DIVISIONAL_EXAM_RESULT.LABEL")}
          </Text>
        </div>
        <div className="col-md-12 col-lg-7 d-flex flex-column gap-4">
          <Controller
            control={control}
            name={BASIC_INFO.RESULT_OF_DIVISIONAL_EXAM}
            render={({ field }) => {
              return (
                <div className="d-flex align-items-center gap-9">
                  <Switch
                    {...register(BASIC_INFO.RESULT_OF_DIVISIONAL_EXAM)}
                    id={BASIC_INFO.RESULT_OF_DIVISIONAL_EXAM}
                    name={BASIC_INFO.RESULT_OF_DIVISIONAL_EXAM}
                    size="sm"
                    controlling
                    onChange={(e) =>
                      setValue(
                        BASIC_INFO.RESULT_OF_DIVISIONAL_EXAM,
                        e.target.checked,
                      )
                    }
                  />
                  <Text color={field.value === true ? "success" : "danger"}>
                    {t(
                      `EMPLOYEE.ACR_INFO.FORM.DIVISIONAL_EXAM_RESULT.${
                        field.value === true ? "PASS" : "FAILED"
                      }`,
                    )}
                  </Text>
                </div>
              );
            }}
          />
        </div>
      </div>

      <div className="row">
        <div className="col-md-12 col-lg-3">
          <Text weight="semibold" size="sm" color="title">
            {t("EMPLOYEE.ACR_INFO.FORM.AGE_EXCEED.LABEL")}
          </Text>
        </div>
        <div className="col-md-12 col-lg-7 d-flex flex-column gap-4">
          <Controller
            control={control}
            name={
              BASIC_INFO.WHETHER_ABOVE_50_YEARS_APPLIED_WITHOUT_EXAMINATION_FOR_PROMOTION
            }
            render={({ field }) => {
              return (
                <div className="d-flex align-items-center gap-9">
                  <Switch
                    {...register(
                      BASIC_INFO.WHETHER_ABOVE_50_YEARS_APPLIED_WITHOUT_EXAMINATION_FOR_PROMOTION,
                    )}
                    id={
                      BASIC_INFO.WHETHER_ABOVE_50_YEARS_APPLIED_WITHOUT_EXAMINATION_FOR_PROMOTION
                    }
                    name={
                      BASIC_INFO.WHETHER_ABOVE_50_YEARS_APPLIED_WITHOUT_EXAMINATION_FOR_PROMOTION
                    }
                    size="sm"
                    controlling
                    onChange={(e) =>
                      setValue(
                        BASIC_INFO.WHETHER_ABOVE_50_YEARS_APPLIED_WITHOUT_EXAMINATION_FOR_PROMOTION,
                        e.target.checked,
                      )
                    }
                  />
                  <Text color={field.value === true ? "success" : "danger"}>
                    {t(
                      `EMPLOYEE.ACR_INFO.FORM.AGE_EXCEED.${
                        field.value === true ? "YES" : "NO"
                      }`,
                    )}
                  </Text>
                </div>
              );
            }}
          />
        </div>
      </div>
      <InputTextRow
        register={{
          ...register(BASIC_INFO.DIVISIONAL_ACTION_CASE_INFORMATION),
        }}
        label="EMPLOYEE.ACR_INFO.FORM.DIVISIONAL_ACTIONS"
        error={errors}
      />
    </div>
  );
};
